import CustomModal from "../CustomModal/CustomModal";
import ReasonForm from "../CustomForms/ReasonForm";

const ActionReasonModal = ({
  label,
  onClose,
  onSubmit,
  submitLoading,
  submitError,
  placeholder = "Please provide feedback",
  title,
  children,
  btnName,
}) => {

  return (
    <CustomModal
      title={title}
      open
      onCancel={onClose}
      centered
      content={
        <>
          {children}
          <ReasonForm
            label={label}
            placeholder={placeholder}
            btnName={btnName}
            submitLoading={submitLoading}
            submitError={submitError}
            onClose={onClose}
            handleOnFormSubmit={onSubmit}
          />
        </>
      }
    />
  );
};

export default ActionReasonModal;
